export default __webpack_public_path__ + "static/media/map-pin.7ccd2839.svg";